import { useContext } from "react";
import { ExcelUploadContext } from "./ExcelUploadContext";

const useExcelUpload = () => {
  return useContext(ExcelUploadContext);
};

export default useExcelUpload;
